import { create, StateCreator } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

// devtools + persist 포함 스토어 팩토리
export const createPersistStore = <T>(
  name: string,
  initializer: StateCreator<T>
) =>
  create<T>()(
    devtools(
      persist(initializer, { name }),
      { name }
    )
  )

// devtools만 포함 스토어 팩토리 (비영속적)
export const createDevStore = <T>(
  name: string,
  initializer: StateCreator<T>
) =>
  create<T>()(
    devtools(initializer, { name })
  )
